import { useEffect, useState } from "react";

import api from "../../services/api";

// Moeda em que a plataforma cobra hoje.
//
// Pelo Asaas é sempre real; pelo Stripe é o que o operador escolheu (euro,
// dólar...). Preço de plano, de módulo e os totais do painel são números sem
// moeda no banco — mostrá-los com "R$" quando a cobrança sai em euro faria a
// tela mentir sobre o que o cliente paga.
//
// Fatura já emitida não usa isto: cada uma guarda a moeda com que nasceu.

// Só uma chamada por sessão: a resposta vale para a tela inteira e não muda
// enquanto ninguém mexe nas configurações globais.
let cache = null;
let pedido = null;

const buscar = () => {
  if (cache) return Promise.resolve(cache);

  if (!pedido) {
    pedido = api
      .get("/subscriptions/mine")
      .then(({ data }) => {
        cache = data?.billing?.currency || "BRL";
        return cache;
      })
      // Fora do sistema — tela de cadastro, tela de login — não há assinatura
      // para consultar, e a resposta é 401. Antes disso derrubar para "BRL",
      // e a landing mostrava R$ num plano cobrado em euro. A rota pública diz
      // a moeda sem exigir sessão.
      .catch(() =>
        api
          .get("/settings/fiscal")
          .then(({ data }) => {
            cache = data?.moeda || "BRL";
            return cache;
          })
          .catch(() => "BRL"),
      )
      .finally(() => {
        pedido = null;
      });
  }

  return pedido;
};

const useMoedaAtiva = () => {
  const [codigo, setCodigo] = useState(cache || "BRL");

  useEffect(() => {
    let vivo = true;

    buscar().then((valor) => {
      if (vivo) setCodigo(valor);
    });

    return () => {
      vivo = false;
    };
  }, []);

  return codigo;
};

// Para os formatadores que vivem fora do componente. Vale o último valor
// conhecido: quem chama o hook na tela força o redesenho quando ele chega.
export const moedaPlataforma = () => cache || "BRL";

// Só o símbolo, para rótulos como "Desconto (€)". Sai do próprio Intl: manter
// uma tabela de símbolos aqui erraria na primeira moeda que ninguém previu.
export const simboloMoeda = (codigo) => {
  try {
    return (0)
      .toLocaleString("pt-BR", {
        style: "currency",
        currency: codigo || "BRL",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      })
      .replace(/[\d\s.,]/g, "");
  } catch {
    return codigo || "";
  }
};

// Formata na moeda passada — a da fatura, quando houver, ou a da plataforma.
export const formatarMoeda = (valor, codigo) =>
  Number(valor || 0).toLocaleString("pt-BR", {
    style: "currency",
    currency: codigo || "BRL",
  });

export default useMoedaAtiva;
